import styled from 'styled-components/native'
import {ProximaNova} from "../App/Components";

export const StyledHeader = styled(ProximaNova)`
  text-align: center;
  margin: 1.5rem 0 4.5rem 0;
`
